module.exports = __webpack_public_path__ + "img/maison5.f3700b23.jpg";